import React, { useState, useEffect } from 'react'
import EstimateRefinancingCalc from './EstimateRefinancingCalc'
import Result from './Result'

const EstimateSavings = () => {
  const [result, setResult] = useState();

  return (
    <div className="estimate-savings-container">
      <div className='text-container text-center'>
        <h3 className="mb-4">Refinance home loan calculator</h3>
        <div>
          Compare your current loan with what we can offer. Find out how much you could save by refinancing with Yard.
        </div>
      </div>

      <div className='calculator-container'>
        <EstimateRefinancingCalc setResult={setResult} />
        <Result result={result} />
      </div>
      <div className='see-all-calc'>
        <div className='text'>Check out our range of handy calculators</div>
        <div className='link'><a href="/calculators">See all calculators</a></div>
      </div>
    </div>
  );
}

export default EstimateSavings
